import { render } from "./EditNotificationView.vue?vue&type=template&id=d6c2de16"
import script from "./EditNotificationView.vue?vue&type=script&lang=js"
export * from "./EditNotificationView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__